module.exports = __webpack_public_path__ + "img/utilizatori.b640f1fc.png";